import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'tt-planner-event',
    templateUrl: './planner-event.component.html',
    styleUrls: ['./planner-event.component.css'],
})
export class PlannerEventComponent {
    @Input()
    ttId: string = '';

    @Input()
    ttItem: any;

    @Input()
    connectedLists: string[] = [];

    @Output()
    ttMouseenter = new EventEmitter<MouseEvent>();

    @Output()
    ttMouseleave = new EventEmitter<MouseEvent>();

    resources: any[] = [];

    itemDragEntered(event: any) {
        console.log(event);
    }

    dropDropZone(event: CdkDragDrop<any>) {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
}
